{
  "section": {
    "title": "Prisperioder",
    "description": "Oversikt over salgsavtalens ulike prisperioder"
  },
  "table": {
    "ariaLabel": "Prisperioder i salgsavtalen",
    "status": "Status",
    "name": "Navn",
    "period": "Periode",
    "lastModified": "Sist endret",
    "created": "Opprettet"
  },
  "statusValues": {
    "planned": "Planlagt",
    "ongoing": "Pågående",
    "completed": "Fullført"
  },
  "list": {
    "loading": "Laster prisperioder",
    "emptyTitle": "Ingen prisperioder",
    "emptyDescription": "Det er ikke registrert noen prisperioder i denne salgsavtalen. Trykk på \"Legg til prisperiode\" for å starte prosessen."
  },
  "copyPage": {
    "breadcrumb": "Kopier prisperiode",
    "title": "Kopier prisperiode",
    "backToSalesAgreement": "Tilbake til salgsavtale",
    "section": {
      "title": "Informasjon om ny prisperiode",
      "description": "Fyll inn nødvendig informasjon om prisperioden"
    },
    "cancel": "Avbryt",
    "save": "Lagre prisperiode",
    "error": {
      "title": "Kunne ikke laste inn kopieringsskjemaet",
      "description": "Noe gikk galt under henting av prisperiodene. Prøv igjen.",
      "retry": "Prøv igjen",
      "goToSalesAgreement": "Tilbake til salgsavtalen"
    }
  },
  "actions": {
    "add": "Legg til prisperiode"
  },
  "detail": {
    "breadcrumb": "Prisperiode",
    "pageTitle": "Prisperiode",
    "backToAgreement": "Tilbake til {{agreementName}}",
    "backToAgreementFallback": "Tilbake til salgsavtale",
    "infoCard": {
      "title": "Periodeinformasjon",
      "period": "Periode",
      "created": "Opprettet",
      "modified": "Sist oppdatert",
      "copiedFrom": "Kopiert fra",
      "editButton": "Endre informasjon"
    },
    "actions": {
      "delete": "Slett",
      "ariaLabel": "Handlinger for prisperioden"
    },
    "deleteDialog": {
      "confirm": {
        "title": "Er du sikker på at du vil slette {{pricePeriodName}}",
        "description": "Alle sortimentpriser og sonetillegg i prisperioden vil gå tapt og må legges til på nytt",
        "action": "Slett prisperioden"
      },
      "blocked": {
        "title": "Kan ikke slette prisperiode",
        "description": "Prisperioden kan ikke slettes fordi den har en status som ikke tillater sletting."
      },
      "errorTitle": "Feil ved sletting",
      "errorDescription": "Det oppstod en feil ved sletting av prisperioden. Prøv igjen."
    },
    "removeAssortment": {
      "confirm": {
        "title": "Er du sikker på at du vil fjerne sortiment {{assortmentIdentity}}?",
        "description": "Priser og endringer du har lagt til vil gå tapt og må fylles inn på nytt",
        "action": "Fjern sortiment"
      },
      "blocked": {
        "title": "Kan ikke fjerne sortiment {{assortmentIdentity}}",
        "description": "Sortimentet er siste variant av et sortiment som er satt som et hovedsortiment i salgsavtalen. Det må fjernes fra hovedsortimenter før det kan fjernes her",
        "close": "Lukk",
        "navigate": "Gå til hovedsortimenter"
      },
      "cancel": "Avbryt",
      "error": {
        "title": "Kunne ikke fjerne sortimentet",
        "description": "Det oppstod en feil ved sletting av sortimentet. Prøv igjen."
      }
    },
    "zoneSurcharges": {
      "title": "Sonetillegg",
      "description": "Oversikt over sonetillegg. Velg ett eller flere sonetillegg for å gjøre endringer, eller legg til et nytt",
      "manageCategoriesButton": "Administrer kategorier",
      "emptyTitle": "Ingen sonetillegg",
      "emptyDescription": "Det er ikke registrert noen sonetillegg i denne prisperioden.\nTrykk på “Legg til kommuner” for å starte prosessen.",
      "unassignedAssortments": {
        "title": "Sortimenter mangler kategori for sonetillegg",
        "description": "sortiment(er) vil ikke få sonetillegg før de er satt i en kategori",
        "action": "Velg kategori for sortimenter"
      },
      "addMunicipalitiesButton": "Legg til kommuner",
      "batchEditZonePricesDialog": {
        "selectedCount": "{{count}} av {{total}} kommune(r) valgt",
        "categoryTitle": "Velg sortimentstyper",
        "categoryDescription": "Velg hvilke sortimenter som skal justeres",
        "closeButton": "Lukk redigering av sonetillegg",
        "adjustmentLabel": "Juster tillegg (NOK)",
        "adjustmentDescription": "Øk eller senk tillegget på rader som er valgt",
        "submitButton": "Oppdater valgte",
        "selectionLimitMessage": "Du kan oppdatere maks {{max}} kommuner om gangen.",
        "toast": {
          "error": {
            "title": "Kunne ikke oppdatere sonetilleggene",
            "description": "Noe gikk galt. Prøv igjen."
          }
        }
      },
      "table": {
        "municipalityColumn": "Kommune",
        "categoryColumnHeader": "{{name}} ({{count}})",
        "unset": "Ikke satt",
        "increase": "Tillegg",
        "decrease": "Fradrag",
        "ariaLabel": "Sonetillegg per kommune",
        "selectAll": "Velg alle kommuner på siden",
        "selectRow": "Velg {{municipality}}",
        "paginationSummary": "Viser {{shown}} av {{total}} sonetillegg",
        "loading": "Laster sonetillegg",
        "error": {
          "title": "Kunne ikke laste sonetillegg",
          "description": "Noe gikk galt. Prøv igjen senere."
        },
        "rowActions": {
          "ariaLabel": "Handlinger for {{municipality}}",
          "editPrices": "Endre priser",
          "deleteRow": "Slett raden"
        }
      },
      "deleteZonePrice": {
        "title": "Er du sikker på at du vil slette sonetillegg for {{municipality}}?",
        "description": "Sonetillegg du har lagt til vil gå tapt og må fylles inn på nytt",
        "confirm": "Slett sonetillegget",
        "toast": {
          "error": {
            "title": "Kunne ikke slette sonetillegget",
            "description": "Noe gikk galt. Prøv igjen."
          }
        }
      },
      "addMunicipalities": {
        "title": "Legg til kommuner",
        "description": "Du kan legge til flere samtidig. Hver kommune legges til som egen rad i tabellen.",
        "cancel": "Avbryt",
        "confirm": "Legg til",
        "placeholder": "Velg kommuner",
        "searchPlaceholder": "Søk etter kommune",
        "noResults": "Ingen kommuner funnet",
        "loadError": "Kunne ikke laste kommuner",
        "toast": {
          "error": {
            "title": "Kunne ikke legge til kommuner",
            "description": "Noe gikk galt. Prøv igjen."
          }
        }
      }
    }
  },
  "assortmentCategories": {
    "breadcrumb": "Administrer kategorier",
    "title": "Administrer kategorier",
    "navigation": {
      "backToPricePeriod": "Tilbake til {{pricePeriodName}}",
      "backToPricePeriodFallback": "Tilbake til prisperiode"
    },
    "section": {
      "title": "Kategorier for sortimenter",
      "description": "Opprett egendefinerte kategorier og flytt sortimenter mellom dem. Ønsker du å fjerne et sortiment må det fjernes fra sortimentslisten."
    },
    "loading": "Laster kategorier",
    "empty": {
      "title": "Ingen sortimenter",
      "description": "Prisperioden må ha sortimenter for å kunne lage kategorier"
    },
    "error": {
      "title": "Kunne ikke laste kategorier",
      "description": "Noe gikk galt under henting av kategoriene. Prøv igjen."
    },
    "unassigned": "Uplassert",
    "missingCategory": "Mangler kategori",
    "list": {
      "categoryName": "Kategorinavn",
      "assortmentCount": "Antall sortiment(er)",
      "assortmentName": "Sortimentnavn",
      "assortmentsAriaLabel": "Sortimenter i {{categoryName}}",
      "noAssortments": "Ingen sortimenter"
    },
    "categoryDropdown": {
      "choose": "Velg kategori",
      "change": "Bytt kategori",
      "ariaLabel": "{{action}} for {{assortment}}",
      "createCategory": "Opprett ny kategori med valgte"
    },
    "assignToast": {
      "error": {
        "title": "Kunne ikke flytte sortimentet",
        "description": "Noe gikk galt under flyttingen av sortimentet. Prøv igjen."
      }
    },
    "createCategory": "Opprett ny kategori",
    "categoryActions": {
      "ariaLabel": "Handlinger for {{categoryName}}",
      "rename": "Endre navn"
    },
    "nameDialog": {
      "cancel": "Avbryt",
      "save": "Lagre",
      "duplicateName": "Kategorien eksisterer allerede, velg et nytt kategorinavn"
    },
    "createDialog": {
      "label": "Kategorinavn",
      "description": "Navnet på den nye kategorien du ønsker å opprette",
      "toast": {
        "error": {
          "title": "Kunne ikke opprette kategorien",
          "description": "Noe gikk galt under opprettelsen av kategorien. Prøv igjen."
        }
      }
    },
    "renameDialog": {
      "description": "Fyll ut et nytt navn for den valgte kategorien",
      "toast": {
        "error": {
          "title": "Kunne ikke endre navn på kategorien",
          "description": "Noe gikk galt under endringen av kategorinavnet. Prøv igjen."
        }
      }
    },
    "deleteDialog": {
      "title": "Er du sikker på at du vil slette {{categoryName}}?",
      "description": "Sortimenter i kategorien vil bli flyttet over til uplassert",
      "toast": {
        "error": {
          "title": "Kunne ikke slette kategorien",
          "description": "Noe gikk galt under slettingen av kategorien. Prøv igjen."
        }
      }
    },
    "selection": {
      "assortment": "Velg {{assortment}}",
      "group": "Velg alle sortimenter i {{categoryName}}"
    },
    "batchMenu": {
      "selectedCount": "{{selectedCount}} sortiment(er) valgt",
      "categoryLabel": "Velg kategori",
      "categoryDescription": "Velg eller opprett en ny kategori for de valgte sortimentene",
      "save": "Lagre",
      "toast": {
        "error": {
          "title": "Kunne ikke flytte sortimentene",
          "description": "Noe gikk galt under flyttingen av sortimentene. Prøv igjen."
        }
      }
    }
  },
  "assortmentPrices": {
    "title": "Sortimentpriser",
    "description": "Oversikt over sortimentpriser. Velg ett eller flere sortimenter for å gjøre endringer, eller legg til et nytt.",
    "batchUpdate": {
      "toast": {
        "error": {
          "title": "Kunne ikke oppdatere prisene",
          "description": "Noe gikk galt under oppdateringen av sortimentprisene. Prøv igjen."
        }
      }
    },
    "columns": {
      "assortment": "Sortiment",
      "priceType": "Pristype",
      "currentPrice": "Salgspris (NOK)",
      "unit": "Enhet",
      "measurementMethod": "Målemetode",
      "priceChange": "Endring (NOK)"
    },
    "selection": {
      "all": "Velg alle sortimenter",
      "row": "Velg {{assortment}}"
    },
    "placeholder": {
      "currentPrice": "Velg salgspris",
      "unit": "Velg enhet",
      "measurementMethod": "Velg målemetode"
    },
    "values": {
      "priceType": {
        "unitPrice": "Enhetspris",
        "dimensionPrice": "Dimensjonspris"
      },
      "unit": {
        "cubicMeter": "m³",
        "log": "stk"
      },
      "measurementMethod": {
        "logMeasured": "Stokkmålt",
        "fmbMeasured": "FMB-målt"
      }
    },
    "priceAdjustment": {
      "placeholder": "–",
      "decrease": "Senk med 1 krone",
      "increase": "Øk med 1 krone"
    },
    "actions": {
      "add": "Legg til sortimenter",
      "viewDimensionMatrix": "Se dimensjonsmatrise",
      "edit": "Endre verdier",
      "uploadDimensionMatrix": "Last opp og bruk dimensjonsmatrise",
      "switchToUnitPrice": "Bytt til enhetspris",
      "editDimensionMatrix": "Endre dimensjonsmatrise",
      "remove": "Fjern sortiment",
      "ariaLabel": "Handlinger for sortiment {{assortmentName}}"
    },
    "batchMenu": {
      "selectedCount": "{{selectedCount}} sortiment(er) valgt",
      "adjustmentLabel": "Juster enhetspris (NOK)",
      "adjustmentDescription": "Øk eller senk salgsprisen på rader som er valgt",
      "submit": "Oppdater valgte"
    },
    "addDialog": {
      "title": "Legg til sortiment",
      "description": "Velg sortiment, pristype, pris og måleverdier",
      "cancel": "Avbryt",
      "confirm": "Legg til",
      "inactiveSuffix": " (deaktivert)",
      "inUseSuffix": " (allerede i bruk)",
      "inactiveSelectedError": "Dette sortimentet er deaktivert i Virkeshandel og kan ikke brukes",
      "assortment": {
        "label": "Velg sortiment",
        "placeholder": "",
        "searchPlaceholder": "Søk etter sortiment",
        "noResults": "Ingen sortimenter funnet"
      },
      "unit": {
        "label": "Velg enhet",
        "placeholder": ""
      },
      "measurementMethod": {
        "label": "Velg målemetode",
        "placeholder": ""
      },
      "price": {
        "label": "Velg salgspris",
        "placeholder": "",
        "dimensionPricePlaceholder": "Styres av dimensjonsmatrise"
      },
      "next": "Neste",
      "priceType": {
        "label": "Velg pristype",
        "dimensionPrice": "Dimensjonspris",
        "unitPrice": "Enhetspris"
      },
      "validation": {
        "assortmentRequired": "Velg et sortiment.",
        "priceTypeRequired": "Velg pristype.",
        "unitRequired": "Velg enhet.",
        "measurementMethodRequired": "Velg målemetode.",
        "priceRequired": "Oppgi salgspris.",
        "priceInvalid": "Oppgi en gyldig salgspris på 0 eller mer.",
        "duplicate": "Sortimentet har allerede en pris med valgt enhet og målemetode.",
        "maxVariants": "Det kan ikke legges til mer enn fire varianter for samme sortiment."
      },
      "errorDescription": "Kunne ikke legge til sortimentpris. Prøv igjen."
    },
    "dimensionMatrixDialog": {
      "title": "Dimensjonsmatrise",
      "description": "Velg en CSV fil og last den opp for å bruke pris fra en dimensjonsmatrise",
      "uploadedFiles": "Opplastede filer",
      "chooseFile": "Velg fil",
      "fileSubtitle": "CSV - Dimensjonsmatrise",
      "removeFile": "Fjern fil",
      "preview": "Forhåndsvisning",
      "previewEmpty": "Ingen dimensjonsmatrise opplastet",
      "previewRegionLabel": "Forhåndsvisning av dimensjonsmatrise",
      "viewDescription": "Lagret dimensjonsmatrise for sortimentet",
      "back": "Tilbake",
      "confirm": "Legg til",
      "cancel": "Avbryt",
      "saveChanges": "Lagre endringer",
      "errors": {
        "wrongFileType": "Kun .csv-filer støttes.",
        "fileTooLarge": "Filen er for stor. Maksimal størrelse er 1 MB.",
        "emptyFile": "Filen er tom.",
        "raggedRows": "Alle rader må ha samme antall kolonner.",
        "axisNotNumeric": "Grenser for diameter og lengde må være tall.",
        "cellNotInteger": "Priser må være heltall uten mellomrom, komma eller desimaler.",
        "negativeValue": "Negative verdier er ikke tillatt.",
        "axisNotAscending": "Grensene må være i strengt stigende rekkefølge.",
        "duplicateLimits": "Grensene må være unike.",
        "missingAxis": "Matrisen må ha minst én diametergrense og én lengdegrense.",
        "matrixTooLarge": "Matrisen kan være maksimalt 50 × 50.",
        "unreadableFile": "Filen kunne ikke leses. Kontroller at den er UTF-8-kodet."
      },
      "toast": {
        "error": {
          "title": "Kunne ikke legge til sortimentpris",
          "description": "Dimensjonsmatrisen ble ikke lagret. Prøv igjen."
        }
      },
      "convertToast": {
        "success": {
          "title": "Dimensjonsmatrisen ble lagret"
        },
        "error": {
          "title": "Kunne ikke lagre dimensjonsmatrisen",
          "description": "Noe gikk galt under lagringen av dimensjonsmatrisen. Prøv igjen."
        }
      }
    },
    "editDialog": {
      "title": "Endre verdier",
      "description": "Sett en annen salgspris, måleenhet eller målemetode for sortimentet",
      "cancel": "Avbryt",
      "confirm": "Lagre",
      "inUseSuffix": " (allerede i bruk)",
      "price": {
        "label": "Endre salgspris",
        "placeholder": ""
      },
      "unit": {
        "label": "Endre enhet",
        "placeholder": ""
      },
      "measurementMethod": {
        "label": "Endre målemetode",
        "placeholder": ""
      },
      "validation": {
        "unitRequired": "Velg enhet.",
        "measurementMethodRequired": "Velg målemetode.",
        "priceRequired": "Oppgi salgspris.",
        "priceInvalid": "Oppgi en gyldig salgspris på 0 eller mer.",
        "duplicate": "Sortimentet har allerede en pris med valgt enhet og målemetode."
      },
      "matrix": {
        "description": "Velg en ny salgspris, måleenhet eller målemetode for sortimentet",
        "price": {
          "label": "Endre pris",
          "placeholder": "Styres av dimensjonsmatrise"
        },
        "unit": {
          "label": "Velg enhet"
        }
      },
      "errorDescription": "Kunne ikke endre sortimentpris. Prøv igjen."
    },
    "switchToUnitPriceDialog": {
      "title": "Ønsker du å bytte til enhetspris?",
      "description": "Dimensjonsmatrisen som er i bruk vil da bli slettet",
      "confirm": "Slett matrise og bytt til enhetspris",
      "cancel": "Avbryt",
      "toast": {
        "success": {
          "title": "Sortimentet er byttet til enhetspris"
        },
        "error": {
          "title": "Kunne ikke bytte til enhetspris",
          "description": "Noe gikk galt under byttet til enhetspris. Prøv igjen."
        }
      }
    },
    "deleteDimensionMatrixDialog": {
      "title": "Ønsker du å slette dimensjonsmatrisen?",
      "description": "Sortimentet får da enhetspris med mindre du laster opp en ny dimensjonsmatrise.",
      "cancel": "Avbryt",
      "confirm": "Slett",
      "toast": {
        "success": {
          "title": "Dimensjonsmatrisen ble slettet"
        },
        "error": {
          "title": "Kunne ikke slette dimensjonsmatrisen",
          "description": "Noe gikk galt under slettingen av dimensjonsmatrisen. Prøv igjen."
        }
      }
    }
  },
  "createDialog": {
    "title": "Legg til prisperiode",
    "cancel": "Avbryt",
    "back": "Tilbake",
    "save": "Lagre prisperiode",
    "next": "Neste",
    "priorPeriodNote": "Perioden baseres automatisk på forrige prisperiode",
    "priorPeriodDescriptionPrefix": "Forrige prisperiode var ",
    "priorPeriodDescriptionSuffix": " fra {{period}}. Ønsker du å basere prisperioden på noe annet, velg alternativet under.",
    "createOtherType": "Opprett en annen type prisperiode",
    "otherTypeTitle": "Annen prisperiode",
    "date": {
      "label": "Dato for prisperiode",
      "description": "Velg start og sluttdato for den nye prisperioden"
    },
    "copyExistingLabel": "Kopier eksisterende prisperiode",
    "copyExistingDescription": "Bruk prisene fra en annen prisperiode som utgangspunkt",
    "emptyLabel": "Tom prisperiode",
    "emptyDescription": "Begynn med en tom prisperiode og legg til sortimenter og priser manuelt"
  },
  "createEmpty": {
    "breadcrumb": "Tom prisperiode",
    "title": "Tom prisperiode",
    "navigation": {
      "backToSalesAgreement": "Tilbake til salgsavtale",
      "cancel": "Avbryt",
      "save": "Lagre prisperiode"
    },
    "section": {
      "title": "Informasjon om prisperioden",
      "description": "Fyll inn nødvendig informasjon om prisperioden"
    },
    "date": {
      "label": "Dato for prisperiode",
      "description": "Velg start og sluttdato for prisperioden"
    },
    "name": {
      "label": "Navn på perioden",
      "description": "Gi prisperioden et beskrivende navn"
    },
    "toast": {
      "error": {
        "title": "Kunne ikke lagre prisperioden",
        "description": "Noe gikk galt under lagringen av prisperioden. Prøv igjen."
      }
    },
    "error": {
      "title": "Kunne ikke laste inn opprettingsskjemaet",
      "description": "Noe gikk galt under henting av salgsavtaleinformasjon. Prøv igjen.",
      "retry": "Prøv igjen",
      "goToSalesAgreement": "Tilbake til salgsavtalen"
    },
    "cancelDialog": {
      "title": "Vil du avbryte opprettelsen?",
      "description": "Alle endringer du har gjort vil gå tapt.",
      "confirmCancel": "Avbryt uten å lagre",
      "continueEditing": "Fortsett redigering"
    }
  },
  "copySource": {
    "timberBuyer": {
      "label": "Velg tømmerkjøper",
      "description": "Søk etter og velg tømmerkjøper med prisperioden du vil kopiere",
      "searchAriaLabel": "Søk etter tømmerkjøper",
      "loading": "Laster tømmerkjøpere",
      "noResults": "Ingen tømmerkjøpere funnet",
      "error": "Kunne ikke laste tømmerkjøpere"
    },
    "pricePeriod": {
      "label": "Velg prisperiode",
      "description": "Søk og velg prisperioden som skal kopieres",
      "searchAriaLabel": "Søk etter prisperiode",
      "loading": "Laster prisperioder",
      "noResults": "Ingen prisperioder funnet",
      "error": "Kunne ikke laste prisperioder"
    }
  },
  "edit": {
    "breadcrumb": "Endre prisperiode",
    "title": "Endre prisperiode",
    "section": {
      "title": "Endre informasjon om prisperioden",
      "description": "Fyll inn nødvendig informasjon om prisperioden"
    },
    "date": {
      "label": "Dato for prisperiode",
      "description": "Velg start og sluttdato for prisperioden",
      "placeholder": "Velg datoer"
    },
    "dateTo": {
      "label": "Sluttdato for prisperiode",
      "description": "Velg sluttdato for prisperioden",
      "placeholder": "Velg dato"
    },
    "name": {
      "label": "Navn på perioden",
      "description": "Gi prisperioden et beskrivende navn"
    },
    "navigation": {
      "backToPricePeriod": "Tilbake til prisperiode",
      "cancel": "Avbryt",
      "save": "Lagre endringer"
    },
    "cancelDialog": {
      "title": "Vil du avbryte redigeringen?",
      "description": "Alle endringer du har gjort vil gå tapt.",
      "confirmCancel": "Avbryt uten å lagre",
      "continueEditing": "Fortsett endring"
    },
    "toast": {
      "error": {
        "title": "Kunne ikke lagre prisperioden",
        "description": "Noe gikk galt under lagringen av prisperioden. Prøv igjen."
      }
    },
    "error": {
      "title": "Kunne ikke laste inn redigeringsskjemaet",
      "description": "Noe gikk galt under henting av prisperioden. Prøv igjen.",
      "retry": "Prøv igjen",
      "goToSalesAgreement": "Tilbake til salgsavtalen"
    }
  },
  "error": {
    "title": "Kunne ikke laste prisperioder",
    "description": "Noe gikk galt under henting av prisperiodene. Prøv igjen."
  },
  "overview": {
    "actions": {
      "ariaLabel": "Handlinger for prisperiode",
      "copyPrices": "Kopier priser til ny periode"
    },
    "deleteDialog": {
      "confirm": {
        "title": "Er du sikker på at du vil slette {{pricePeriodName}}",
        "description": "Alle sortimentpriser og sonetillegg i prisperioden vil gå tapt og må legges til på nytt",
        "action": "Slett prisperioden"
      },
      "blockedActive": {
        "title": "Kan ikke slette {{pricePeriodName}}",
        "description": "Prisperioden er pågående og kan ikke slettes. Ønsker du en ny prisperiode kan sluttdato endres og en ny prisperiode opprettes."
      },
      "blockedCompleted": {
        "title": "Kan ikke slette {{pricePeriodName}}",
        "description": "Prisperioder som er fullførte kan ikke slettes."
      }
    },
    "deleteToast": {
      "success": "Prisperioden ble slettet"
    }
  },
  "copyActions": {
    "cancel": "Avbryt",
    "save": "Lagre prisperiode",
    "toast": {
      "error": {
        "title": "Kunne ikke lagre prisperioden",
        "description": "Noe gikk galt under lagringen av prisperioden. Prøv igjen."
      }
    },
    "cancelDialog": {
      "title": "Vil du avbryte oppretting av prisperiode?",
      "description": "All informasjon du har fylt ut vil gå tapt og må fylles inn på nytt.",
      "confirmCancel": "Avbryt uten å lagre",
      "continueCreating": "Fortsett oppretting"
    }
  }
}
